import React, { memo, useContext, useState } from 'react';
import cryllexSvg from "./../../../../assets/images/crillex.svg"
import TronContext from '../../../../TronContext';
import { Button, Form } from 'react-bootstrap';
import { ModalContext } from '../../../../Pages/Layaut';
import { setPayingCustomerAgreementData } from '../../../../Constants';
import { Link } from 'react-router-dom';
import ApiService from '../../../../Services/ApiService';
import PaymentDataContext from '../../../../PaymentDataContext.jsx';

const TronPayBtn = memo(({
    price,
    isTransactionValidated,
    pay,
    selectedToken,
    paySuccess,
    payError,
    selectedChain,
    isLoadingPay,
}) => {

    const { paymentData } = useContext(PaymentDataContext);
    const { sendTransaction, account } = useContext(TronContext);
    const { setModalContent } = useContext(ModalContext);
    const [isAgree, setIsAgree] = useState(false);

    // const _sendTransaction = (to = "", amount = 0) => {
    //     sendTransaction(to, amount, selectedToken).then((txHash) => {
    //         console.log('Transaction hash:', txHash);
    //         paySuccess(txHash, selectedChain.id)
    //     }).catch(error => {
    //         payError(error?.name, error?.message)
    //     })
    // }

    const _sendTransaction = async (to = "", amount = 0) => {
        if (!to || !selectedToken) return;

        try {
            const txHash = await sendTransaction(to, amount, selectedToken);
            console.log("Transaction hash:", txHash);
            paySuccess(txHash, selectedChain.id);
        } catch (error) {
            payError(error.name, error.message);
        }
    };

    const onSetAgreementData = () => {
        setModalContent({
            show: true,
            size: "lg",
            actionButtonTitle: "Agree and Accept",
            actionButtonCb: () => {
                setIsAgree(true);
            },
            title: "Paying Customer Cryllex Terms of Use/Agreement",
            children: <div>
                {setPayingCustomerAgreementData()}
            </div>,
        })
    }

    const onCheckBoxChange = (event) => {
        setIsAgree(event.target.checked)
    }

    // return <button onClick={() => {
    //     sendTransaction("0xE9eFD4F63Cb1060E592415F7F0cef294F48B8899", 1)
    // }}>
    //     Pay
    // </button>

    return paymentData ? <div className='h-100 d-flex justify-content-evenly align-items-center flex-column'>
        <Button
            type='button'
            variant='primary'
            size='lg'
            className='w-100'
            style={{ maxWidth: "400px", fontWeight: "500", marginTop: "10px" }}
            disabled={isLoadingPay || !isTransactionValidated || !account || !isAgree ? true : false}
            onClick={() => {
                if (isTransactionValidated && account && !isLoadingPay) {
                    pay(_sendTransaction);
                }
            }}
        >
            <div className='d-flex justify-content-between'>
                <div className='d-flex align-items-center gap-2'>
                    <img src={cryllexSvg} alt="/" />
                    {
                        isLoadingPay ? "Loading..." : "Pay"
                    }

                </div>
                {/* <div>
                    {
                        price ?
                            <span className="ms-2"><b>{price} {selectedToken?.slug}</b></span>
                            : null
                    }
                </div> */}
            </div>
        </Button>
        <div>
            <Form.Group controlId="isAgree">
                <Form.Check
                    type="checkbox"
                    label={<small>I’ve read and agree to the <Link className='text-primary' to="#" onClick={(event) => {
                        event.stopPropagation();
                        onSetAgreementData();
                    }}>Paying Customer Agreement</Link>.</small>}
                    checked={isAgree}
                    onChange={event => onCheckBoxChange(event)}
                />
            </Form.Group>
        </div>
    </div> : null
})

export default TronPayBtn;



